import DropboxPage from './DropboxPage';

export default DropboxPage;
